import { SvgIcon, SvgIconProps } from "@mui/material";

export const GridIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <rect
        width="18"
        height="18"
        x="3"
        y="3"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        rx="2"
      />
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M3 12h18M12 21V3"
      />
    </svg>
  </SvgIcon>
);
